import { Card } from "antd";
import AdminLayout from "components/layouts/AdminLayout";
import EndTendering from "components/tenders/singleLoan/EndTendering";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router";
import { TranslateString } from "Utils/Common";

function EndTenderingPage(props: any) {
    const navigate = useNavigate();
    props = { ...props, ...useParams() }

    return (
        <AdminLayout>
            <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left">
                <h4 className="cu-m-0 cu-p-0">
                    <button className="ant-btn cu-border-0 cu-btn" onClick={() => navigate(-1)}><FaArrowLeft style={{ fontWeight: 900, fontSize: '18px' }} /></button>
                    &nbsp;
                    <button className="ant-btn cu-border-0 cu-btn h4">{TranslateString('end_tendering_select_winner_moderator')}</button>
                </h4>
            </div>
            <Card className="cu-table-small">
                <EndTendering props={props} />
            </Card>
        </AdminLayout>
    );
}

export default EndTenderingPage;